/**
 * TOT — keep the inline header search dropdown clickable in Safari.
 *
 * THE BUG (Safari/WebKit only, desktop header search):
 * `snippets/search-inline.liquid` reveals its results panel with
 * `.search-inline:focus-within` and gates the closed state with `pointer-events: none`.
 * Safari — unlike Chrome and Firefox — does NOT move focus to a link when you press the
 * mouse on it; it only blurs whatever was focused, leaving `document.activeElement` on
 * <body>. So the instant a shopper pressed down on a search result:
 *
 *   mousedown -> input blurs -> `:focus-within` stops matching -> panel flips to
 *   `pointer-events: none` -> mouseup lands on nothing -> no click event -> no navigation.
 *
 * Results were visible but completely dead. In Chromium the anchor takes focus, focus
 * stays inside `.search-inline`, and the same click navigates fine — which is why this
 * only ever showed up in Safari. Reproduced in WebKit 2026-08-14.
 *
 * THE FIX:
 * Suppress the DEFAULT ACTION of mousedown inside the results panel. The focus change is
 * that default action, so preventing it keeps focus on the input, keeps `:focus-within`
 * matching, and lets the panel stay live through mouseup. The click event itself is left
 * untouched — links navigate, buttons fire, cmd/ctrl-click still opens a new tab.
 *
 * Scoped to `.search-inline` on purpose: the search MODAL (`snippets/search-modal.liquid`)
 * never gates its panel on focus, so it does not have this bug and is left alone.
 */

const PANEL_SELECTOR = '.search-inline .predictive-search-form__content-wrapper';

// Delegated at the document, in the capture phase: the predictive-search component
// morph()s the panel's contents on every keystroke, so anything bound to the result
// nodes themselves would be thrown away as soon as the shopper typed another letter.
document.addEventListener(
  'mousedown',
  (event) => {
    // Primary button only — leave middle-click (open in new tab) and context menus alone.
    if (event.button !== 0) return;

    const target = event.target;
    if (!(target instanceof Element)) return;
    if (!target.closest(PANEL_SELECTOR)) return;

    event.preventDefault();
  },
  { capture: true }
);
